import Template from "../Template";

import StoreCard, { WarehouseCard } from "../../components/StoreCard";
import { useNavigate } from "react-router-dom";
import "../../styles/stores/mystores.css";
import CreateStore, { CreateStoreWarehouseModal } from "./CreateStore";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Plus } from "lucide-react";
import notSubImage from "../../assetsStatic/notSub.png";
import noStore from "../../assetsStatic/emptyStore.png";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
import { editProfileURL } from "../../api/endpoints";
import { setUser } from "../../slice/webStoreUserSlice";
import Spinner from "../../components/uxCollections/Loaders";
import { setPage } from "../../slice/storeSlice";

let cloudinaryReduceOptimizeUrl = "https://res.cloudinary.com/demo/image/fetch/w_120,f_auto,q_auto/";
const Mystores = () => {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.webStoreUser);
  const [refetchCounter, setRefetchCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // params from url if there is any
    const params = new URLSearchParams(window.location.search);
    const userID = params.get("userID");
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");

    // params from url

    if (userID && accessToken && refreshToken) {
      // store tokens
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      // wait for user fetch
      const init = async () => {
        const user = await fetchUser(userID);
        if (!user) {
          return;
        }
      };

      init();
    } else {
      if (user === null || user === undefined || Object.keys(user).length === 0) {
        navigate("/sign-in");
      }
    }
    setLoading(false);

    dispatch(setPage(null));
  }, []);

  const fetchUser = async (userID, retryCount = 0) => {
    try {
      setLoading(true);

      const response = await fetch(editProfileURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }

      const user = await response.json();

      dispatch(setUser(user));

      setLoading(false);

      return user;
    } catch (error) {
      if (retryCount >= 3) {
        uiAlert("Failed to fetch user data after multiple attempts. Please try again later.", "error");

        navigate("/sign-in");

        setLoading(false);

        return null;
      }

      uiAlert("Error fetching user data. Retrying...", "warning");

      // wait 3 seconds before retry
      await new Promise((resolve) => setTimeout(resolve, 3000));

      return fetchUser(userID, retryCount + 1); // ✅ return retry result
    }
  };

  if (loading || !user) {
    console.log("loading user data...");

    return <Spinner position='fixed' />;
  }

  if (!user.userIsSubscribed) {
    console.log("user is not subscribed");

    return (
      <Template>
        <div className='userNotSubscribeddiv23'>
          <div className='userNotSubscribeddiv23'>
            <div>
              <img style={{ marginBottom: "12px" }} src={notSubImage} />
              <h2>You are not subscribed YET 😒</h2>
              <p className='descriptionPar12'>
                You need to subscribe to create and manage your stores. Don't worry <br /> We have cheap packages for every busines type <br /> Select a package
                that suits you.{" "}
              </p>
              <button onClick={() => navigate("/settings/subscription")}>Subscribe Now</button>
            </div>
          </div>
        </div>
      </Template>
    );
  }

  return (
    <>
      <Template>
        {user && user?.userIsSubscribed && (
          <>
            <div className='store-management-container-unique'>
              {!user?.store.length ? (
                <div className='emptyStoreDiv'>
                  {/* <img src={noStore} /> */}
                  <div class='emptystate__icon__container__2m7r6'>
                    <div class='emptystate__icon__background__4n9k1'>
                      <div class='emptystate__storefront__8q4w7'>
                        <div class='emptystate__awning__3v2n8'>
                          <div class='emptystate__awning__stripe__1d8p5'></div>
                          <div class='emptystate__awning__stripe__1d8p5'></div>
                          <div class='emptystate__awning__stripe__1d8p5'></div>
                          <div class='emptystate__awning__stripe__1d8p5'></div>
                        </div>
                        <div class='emptystate__building__9m3k2'></div>
                      </div>
                      <div class='emptystate__magnifying__glass__7w8x9'>
                        <div class='emptystate__magnifying__circle__4k7m3'>
                          <div class='emptystate__magnifying__handle__2j9n4'></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2 style={{ marginTop: "12px" }}>No Business created</h2>
                  <p style={{ textAlign: "center" }} className='descriptionPar12'>
                    You are yet to create a business. <br /> Click the button below to create one.
                  </p>
                </div>
              ) : (
                <>
                  <section>
                    <h1 className='section-header-unique-store'>My Businesses</h1>
                    <div className='stores-horizontal-grid-unique'>
                      {user?.store.map((store, index) => (
                        <StoreCard
                          key={store._id}
                          storeCount={index}
                          maxStore={user?.maxStore}
                          name={store.storeName}
                          address={store.storeAddress}
                          image={store.storeImage}
                          storeID={store._id}
                          rating={store.averageRating}
                          followers={store.numberOfFollowers}
                        />
                      ))}
                    </div>
                  </section>

                  {!user?.warehouse.length ? (
                    <div className='emptyStoreDiv2'></div>
                  ) : (
                    <section>
                      <h1 className='section-header-unique-store'>My Warehouse</h1>
                      <div className='warehouse-horizontal-grid-unique'>
                        {user?.warehouse.map((warehouse, index) => (
                          <WarehouseCard
                            key={index}
                            name={warehouse.warehouseName}
                            address={warehouse.warehouseAddress}
                            image={warehouse.warehouseIcon}
                            warehouse={true}
                            warehouseID={warehouse._id}
                          />
                        ))}
                      </div>
                    </section>
                  )}
                </>
              )}

              {/* Add Button */}
              <button onClick={() => setOpenModal(true)} className='add-button-unique-floating' aria-label='Add new store or warehouse'>
                <Plus />
              </button>
            </div>
          </>
        )}
      </Template>
      {/* {openModal && <CreateStoreWarehouseModal closeModal={setOpenModal} />} */}
      {openModal && <CreateStore closeModal={setOpenModal} />}
    </>
  );
};

export default Mystores;
